import { cn } from "../../helpers"

const root = cn("inline-flex flex-col items-start")
const visibleBlock = (className?: string) => cn("inline-block grow-0", className)
const hiddenBlock = cn("invisible block h-0 overflow-hidden")

export { root, visibleBlock, hiddenBlock }
